import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { productsApi } from "api/api/productsApi/productsApi";
import i18n from "i18n";
import { toast } from "react-toastify";

export const deleteProductByProductId = createAsyncThunk<void, number>(
  "products/deleteProduct",
  async (productId, { rejectWithValue }) => {
    const t = i18n.t.bind(i18n);
    try {
      const data = await productsApi.deleteProductByProductId(productId);

      toast.success(String(t("toast.deleteProductSuccess")));

      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while deleting product", error?.response?.data);

        const serverMessage = (error?.response?.data as any)?.message;
        toast.error(serverMessage || t("toast.deleteProductError"));

        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while deleting product", error);

        toast.error(String(t("toast.unknownProductError")));

        return rejectWithValue(t("toast.unknownProductError"));
      }
    }
  }
);
